import { getActiveBoard } from '../../board-context.js';
import { formatBeginnerPinLabel } from '../pins/pin-selector.js';

export type OledI2cUi =
  | {
      mode: 'fixed';
      /** Student-facing label, e.g. "SCL-A5 | SDA-A4". */
      label: string;
      scl: string;
      sda: string;
    }
  | {
      mode: 'selectable';
    };

function fixedLabel(scl: string | number, sda: string | number): OledI2cUi {
  const board = getActiveBoard();
  const sclText = formatBeginnerPinLabel(scl, board);
  const sdaText = formatBeginnerPinLabel(sda, board);
  return {
    mode: 'fixed',
    label: `SCL-${sclText} | SDA-${sdaText}`,
    scl: String(scl),
    sda: String(sda),
  };
}

/**
 * Board-aware I2C pin UI for Configure OLED.
 * Fixed boards show pins on the block; ESP32 lets students pick SCL/SDA.
 */
export function getOledI2cUi(boardId = getActiveBoard()?.id ?? ''): OledI2cUi {
  const id = boardId.toLowerCase();
  const board = getActiveBoard();
  const i2c = board?.pins?.i2c;

  if (id === 'arduino-uno' || id === 'arduino-nano') {
    return fixedLabel('A5', 'A4');
  }

  if (id === 'arduino-mega-2560') {
    return fixedLabel(21, 20);
  }

  if (id === 'skyrover-esp32-s3') {
    // Prefer board I²C mapping when present (default SDA 8 / SCL 9).
    if (i2c?.scl != null && i2c?.sda != null) {
      return fixedLabel(i2c.scl, i2c.sda);
    }
    return fixedLabel(9, 8);
  }

  // ESP32 DevKit / ESP8266: student selects pins.
  if (id.includes('esp32') || id.includes('esp8266')) {
    return { mode: 'selectable' };
  }

  if (i2c?.scl != null && i2c?.sda != null) {
    return fixedLabel(i2c.scl, i2c.sda);
  }

  return fixedLabel('A5', 'A4');
}
